import React from 'react';
import {
    Box, Chip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const tableData = [
    { alloc: 0,      bonus: 0,  price: 0.8650, total: null,   at090: '$0.90',    roi: 4.0  },
    { alloc: 500,    bonus: 6,  price: 0.8157, total: 613,    at090: '$552',     roi: 10.3 },
    { alloc: 2000,   bonus: 10, price: 0.7862, total: 2544,   at090: '$2,290',   roi: 14.5 },
    { alloc: 5000,   bonus: 12, price: 0.7723, total: 6474,   at090: '$5,827',   roi: 16.5 },
    { alloc: 10000,  bonus: 14, price: 0.7587, total: 13180,  at090: '$11,862',  roi: 18.6 },
    { alloc: 20000,  bonus: 16, price: 0.7457, total: 26821,  at090: '$24,139',  roi: 20.7 },
    { alloc: 50000,  bonus: 20, price: 0.7208, total: 69365,  at090: '$62,429',  roi: 24.9 },
    { alloc: 100000, bonus: 26, price: 0.6865, total: 145665, at090: '$131,099', roi: 31.1 },
    { alloc: 150000, bonus: 30, price: 0.6654, total: 225434, at090: '$202,891', roi: 35.3 },
];

const fmt = (n) => n.toLocaleString();

const TierTable = () => {
    const theme  = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const accent = theme.palette.primary.main;

    const tableBg     = isDark ? '#0d1520'                : 'background.paper';
    const headerBg    = isDark ? '#111d2e'                : '#f9f6f0';
    const rowAlt      = isDark ? 'rgba(255,255,255,0.02)' : '#fafaf8';
    const rowHover    = isDark ? 'rgba(210,157,92,0.07)'  : 'rgba(200,144,74,0.05)';
    const borderColor = isDark ? 'rgba(255,255,255,0.07)' : '#e5ddd0';
    const textMain    = isDark ? '#ffffff'                : '#1a1a2e';
    const textSub     = isDark ? 'rgba(255,255,255,0.4)'  : '#6b7280';
    const goldColBg   = isDark ? 'rgba(210,157,92,0.08)'  : 'rgba(200,144,74,0.07)';

    const thSx = {
        bgcolor: headerBg,
        color: textSub,
        fontWeight: 700,
        fontSize: '0.62rem',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        borderBottom: `2px solid ${borderColor}`,
        borderRight: `1px solid ${borderColor}`,
        py: 1,
        px: 1.25,
        whiteSpace: 'nowrap',
    };

    const tdSx = {
        color: textMain,
        borderBottom: `1px solid ${borderColor}`,
        borderRight: `1px solid ${borderColor}`,
        py: 0.75,
        px: 1.25,
        fontSize: '0.78rem',
    };

    return (
        <Box>
            <TableContainer component={Paper} sx={{
                boxShadow: isDark ? '0 4px 20px rgba(0,0,0,0.4)' : '0 2px 12px rgba(10,16,32,0.07)',
                border: `1px solid ${borderColor}`,
                borderRadius: 1.5,
                bgcolor: tableBg,
                overflowX: 'auto',
                mb: 1.25,
            }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ ...thSx, textAlign: 'left' }}>Allocation</TableCell>
                            <TableCell align="center" sx={thSx}>Bonus</TableCell>
                            <TableCell align="right" sx={thSx}>Price</TableCell>
                            <TableCell align="right" sx={thSx}>EBONDS</TableCell>
                            <TableCell align="right" sx={{ ...thSx, bgcolor: accent, color: '#fff' }}>@ $0.90</TableCell>
                            <TableCell align="right" sx={thSx}>ROI</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {tableData.map((row, i) => (
                            <TableRow
                                key={i}
                                sx={{
                                    bgcolor: i % 2 === 0 ? tableBg : rowAlt,
                                    '&:hover': { bgcolor: rowHover },
                                    transition: 'background 0.15s',
                                }}
                            >
                                <TableCell sx={{ ...tdSx, fontWeight: 700 }}>
                                    ${fmt(row.alloc)}
                                </TableCell>
                                <TableCell align="center" sx={tdSx}>
                                    <Chip
                                        label={`+${row.bonus}%`}
                                        size="small"
                                        sx={{
                                            bgcolor: isDark ? 'rgba(210,157,92,0.12)' : 'rgba(200,144,74,0.12)',
                                            color: accent, fontWeight: 700,
                                            fontSize: '0.65rem', height: 18, borderRadius: 0.75,
                                        }}
                                    />
                                </TableCell>
                                <TableCell align="right" sx={{ ...tdSx, color: textSub, fontFamily: 'monospace', fontSize: '0.74rem' }}>
                                    ${row.price.toFixed(4)}
                                </TableCell>
                                <TableCell align="right" sx={{ ...tdSx, fontFamily: 'monospace' }}>
                                    {row.total ? fmt(row.total) : '—'}
                                </TableCell>
                                <TableCell align="right" sx={{ ...tdSx, bgcolor: goldColBg, color: accent, fontWeight: 700, fontFamily: 'monospace' }}>
                                    {row.at090}
                                </TableCell>
                                <TableCell align="right" sx={{ ...tdSx, color: '#22c55e', fontWeight: 800, fontFamily: 'monospace' }}>
                                    {row.roi.toFixed(1)}%
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default TierTable;
